import forEach from 'lodash/forEach';
import * as types from 'constants/ActionTypes';
import { list, custom } from 'utils/Api';

function requestOrgChartData() {
  return {
    type: types.ORGCHART_REQUEST_DATA,
  };
}

function requestOrgChartDataSuccess(data) {
  return {
    type: types.ORGCHART_REQUEST_DATA_SUCCESS,
    data,
  };
}

function requestOrgChartDataFailure(error) {
  return {
    type: types.ORGCHART_REQUEST_DATA_FAILURE,
    error,
  };
}

export function setActive(id) {
  return {
    type: types.ORGCHART_SET_ACTIVE_NODE,
    nodeId: id,
  };
}

/*
 * formatting for basicprimitives itemconfig (https://www.basicprimitives.com/index.php?option=com_local&view=local&Itemid=43&lang=en#primitives.orgdiagram.ItemConfig)
 */

const formatEmployee = (employee, ind) => {
  const newEmp = {
    id: ind,
    parent: `companyUnit${employee.DepartmentID}`,
    OrgCompanyUnitID: employee.DepartmentID,
    templateName: 'employeeTemplate',
    description: employee.Title,
    title: employee.Name,
    phone: employee.Phone,
    email: employee.Email,
    itemTitleColor: '#859DEE',
    hasSelectorCheckbox: false,
    hasButtons: false,
  };
  return newEmp;
};

/*
 * Fetch only needed info for the OrgChart and add the className department
 * the className prop is used for css by the orgChart library
 */
const formatCompanyUnit = (unit) => {
  const retUnit = {
    title: unit.OrgCompanyUnitName,
    id: `companyUnit${unit.OrgCompanyUnitID}`,
    label: unit.OrgCompanyUnitName,
    showLabel: true,
    OrgCompanyUnitID: unit.OrgCompanyUnitID,
    OrgCompanyID: unit.OrgCompanyID,
    OrgCompanyUnitParentID: unit.OrgCompanyUnitParentID,
    itemTitleColor: '#63a4ff',
    templateName: 'companyUnitTemplate',
    setChildrenMatrix: true,
  };
  if (unit.OrgCompanyUnitParentID === 0) {
    retUnit.parent = `company${unit.OrgCompanyID}`;
  } else {
    retUnit.parent = `companyUnit${unit.OrgCompanyUnitParentID}`;
  }
  return retUnit;
};

/*
 * Fetch only needed info for the OrgChart and add the className company
 * the className prop is used for css by the orgChart library
 */
const formatCompany = company => ({
  title: company.OrgCompanyName,
  showLabel: true,
  label: company.OrgCompanyName,
  OrgCompanyID: company.OrgCompanyID,
  id: `company${company.OrgCompanyID}`,
  parent: null,
  templateName: 'companyTemplate',
  itemTitleColor: '#004ba0',
});

function fetchEmployees() {
  return (dispatch, getState) => {
    const { loginReducer: { user: { token } } } = getState();
    const config = {
      url: 'api/HrData/EmployeesSearch',
      headers: { Authorization: `Bearer ${token}` },
    };

    return custom(config)
      .then(({ data }) => data.map(formatEmployee))
      .catch((err) => { throw (err); });
  };
}

/*
 * Checks all companyUnits, if a companyunit has a child that is also a companyunit then the children will be
 * formatted horizontally instead of in a matrix, companyUnits with only employees as children will have it's
 * children layout in a matrix
 * this property is called childrenPlacementType and is set in EmployeeOrgChart container in the render function.
 */

const formatCompanyUnitChildren = (companyUnits) => {
  let newUnits = companyUnits;
  forEach(companyUnits, (unit) => {
    if (unit.OrgCompanyUnitParentID !== 0) {
      newUnits = newUnits.map((newUnit) => {
        const retUnit = newUnit;
        if (newUnit.OrgCompanyUnitID === unit.OrgCompanyUnitParentID) {
          retUnit.setChildrenMatrix = false;
        }
        return retUnit;
      });
    }
  });
  return newUnits;
};

function fetchCompanyUnit() {
  return (dispatch, getState) => {
    const { loginReducer: { user: { token } } } = getState();
    const config = { entity: 'OrgCompanyUnit', headers: { Authorization: `Bearer ${token}` } };
    return list(config)
      .then(({ data }) => data
        .filter(unit => !unit.Disabled)
        .map(formatCompanyUnit))
      .then(res => formatCompanyUnitChildren(res))
      .catch((err) => { throw err; });
  };
}

function fetchCompany() {
  return (dispatch, getState) => {
    const { loginReducer: { user: { token } } } = getState();
    const config = { entity: 'OrgCompany', headers: { Authorization: `Bearer ${token}` } };
    return list(config)
      .then(({ data }) => data.map(formatCompany))
      .catch((err) => { throw (err); });
  };
}

export function fetchData() {
  return (dispatch) => {
    dispatch(requestOrgChartData());
    Promise.all([
      dispatch(fetchCompany()),
      dispatch(fetchCompanyUnit()),
      dispatch(fetchEmployees()),
    ])
      .then(
        ([companies, units, employees]) => {
          dispatch(requestOrgChartDataSuccess([...companies, ...employees, ...units]));
        },
        err => dispatch(requestOrgChartDataFailure(err)),
      );
  };
}



// WEBPACK FOOTER //
// ./src/actions/EmployeeOrgChart.js